const mobilePanel = document.querySelector("[data-mobile-panel]");
const menuToggle = document.querySelector(".menu-toggle");
const closePanel = document.querySelector(".mobile-panel__close");
const mobileLinks = document.querySelectorAll(".mobile-panel a");
const navItems = document.querySelectorAll(".nav-item--dropdown");
const desktopDropdownLinks = document.querySelectorAll(".nav-dropdown a");
const mobileAccordions = document.querySelectorAll("[data-mobile-accordion]");

function closeDesktopDropdowns(exceptItem) {
  navItems.forEach((item) => {
    if (item === exceptItem) return;
    item.classList.remove("is-open");
    item.querySelector(".nav-trigger")?.setAttribute("aria-expanded", "false");
  });
}

navItems.forEach((item) => {
  const trigger = item.querySelector(".nav-trigger");

  trigger?.addEventListener("click", (event) => {
    event.stopPropagation();
    const willOpen = !item.classList.contains("is-open");

    closeDesktopDropdowns(item);
    item.classList.toggle("is-open", willOpen);
    trigger.setAttribute("aria-expanded", String(willOpen));
  });
});

desktopDropdownLinks.forEach((link) => link.addEventListener("click", () => closeDesktopDropdowns()));

document.addEventListener("click", (event) => {
  if (!event.target.closest(".main-nav")) {
    closeDesktopDropdowns();
  }
});

document.addEventListener("keydown", (event) => {
  if (event.key === "Escape") {
    closeDesktopDropdowns();
    setMenu(false);
  }
});

function setMenu(open) {
  if (!mobilePanel || !menuToggle) return;
  mobilePanel.hidden = !open;
  document.body.classList.toggle("menu-open", open);
  menuToggle.setAttribute("aria-expanded", String(open));

  if (!open) {
    document.querySelectorAll(".mobile-menu-group.is-open").forEach((group) => {
      group.classList.remove("is-open");
      group.querySelector("[data-mobile-accordion]")?.setAttribute("aria-expanded", "false");
    });
  }
}

menuToggle?.addEventListener("click", () => setMenu(true));
closePanel?.addEventListener("click", () => setMenu(false));
mobileLinks.forEach((link) => link.addEventListener("click", () => setMenu(false)));

mobileAccordions.forEach((trigger) => {
  trigger.addEventListener("click", () => {
    const group = trigger.closest(".mobile-menu-group");
    const willOpen = !group?.classList.contains("is-open");

    document.querySelectorAll(".mobile-menu-group.is-open").forEach((openGroup) => {
      if (openGroup === group) return;
      openGroup.classList.remove("is-open");
      openGroup.querySelector("[data-mobile-accordion]")?.setAttribute("aria-expanded", "false");
    });

    group?.classList.toggle("is-open", willOpen);
    trigger.setAttribute("aria-expanded", String(willOpen));
  });
});

document.querySelector(".newsletter-form")?.addEventListener("submit", (event) => {
  event.preventDefault();
  const input = event.currentTarget.querySelector("input");
  if (input) {
    input.value = "";
    input.placeholder = "You are on the fresh list";
  }
});

function ensureFooterLinks() {
  const footer = document.querySelector(".site-footer");
  if (!footer) return;

  const existingLinks = footer.querySelector(".footer-links");
  if (existingLinks && existingLinks.querySelectorAll(".footer-link-list a").length >= 5) return;

  existingLinks?.remove();
  const footerBottom = footer.querySelector(".footer-bottom");
  const links = document.createElement("div");
  links.className = "footer-links reveal is-visible";
  links.innerHTML = `
    <div class="footer-link-column footer-link-column--brand">
      <p>Play Fresh. Stay Fizzy.</p>
    </div>
    <nav class="footer-link-column" aria-label="Quick links">
      <h3>Quick links</h3>
      <ul class="footer-link-list" role="list">
        <li><a href="/policies/refund-policy">Return policy</a></li>
        <li><a href="/policies/privacy-policy">Privacy Policy</a></li>
        <li><a href="/policies/terms-of-service">Terms of service</a></li>
        <li><a href="/policies/shipping-policy">Shipping policy</a></li>
        <li><a href="/policies/subscription-policy">Subscription policy</a></li>
      </ul>
    </nav>
    <div class="footer-link-column footer-contact">
      <h3>Contact US</h3>
      <address>
        <span>Yuzz sports trading inc.</span>
        <span>39 Riviera Dr, Markham, ON L3R 5M1, Canada</span>
        <a href="tel:+19053486465">905-348-6465</a>
        <a href="mailto:emilyuu0219@gmail.com">emilyuu0219@gmail.com</a>
      </address>
    </div>
  `;

  footer.insertBefore(links, footerBottom);
}

ensureFooterLinks();

document.querySelectorAll("[data-yuzz-sort]").forEach((select) => {
  select.addEventListener("change", () => {
    select.form?.submit();
  });
});

document.querySelectorAll("[data-yuzz-filter-drawer]").forEach((drawer) => {
  drawer.addEventListener("toggle", () => {
    document.body.classList.toggle("yuzz-filter-open", drawer.open);
  });
});

document.querySelectorAll("[data-yuzz-filter-close]").forEach((button) => {
  button.addEventListener("click", () => {
    const drawer = button.closest("[data-yuzz-filter-drawer]");
    if (drawer) {
      drawer.open = false;
      document.body.classList.remove("yuzz-filter-open");
    }
  });
});

document.querySelectorAll("[data-carousel-control]").forEach((button) => {
  button.addEventListener("click", () => {
    const rail =
      document.getElementById(button.dataset.carouselTarget) ||
      button.closest(".new-arrivals")?.querySelector("[data-carousel-rail]");

    if (!rail) return;

    const card = rail.querySelector(".product-card");
    const styles = window.getComputedStyle(rail);
    const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
    const cardWidth = card?.getBoundingClientRect().width || rail.clientWidth * 0.8;
    const direction = button.dataset.carouselControl === "prev" ? -1 : 1;

    rail.scrollBy({
      left: direction * (cardWidth + gap),
      behavior: "smooth",
    });
  });
});

document.querySelectorAll("[data-shop-look]").forEach((look) => {
  const triggers = look.querySelectorAll("[data-shop-look-trigger]");
  const products = look.querySelectorAll("[data-shop-look-product]");

  triggers.forEach((trigger) => {
    trigger.addEventListener("click", () => {
      const target = trigger.dataset.shopLookTrigger;

      triggers.forEach((button) => {
        button.classList.toggle("is-active", button === trigger);
      });

      products.forEach((product) => {
        product.classList.toggle("is-active", product.dataset.shopLookProduct === target);
      });
    });
  });
});

const discountModal = document.querySelector("[data-yuzz-discount-modal]");
const discountStorageKey = "yuzz_discount_modal_dismissed";

function closeDiscountModal() {
  if (!discountModal) return;
  discountModal.hidden = true;
  document.body.classList.remove("yuzz-modal-open");
  try {
    window.localStorage.setItem(discountStorageKey, "true");
  } catch (error) {
    // Ignore storage failures in private browsing.
  }
}

if (discountModal) {
  let shouldShowDiscount = true;
  try {
    shouldShowDiscount = window.localStorage.getItem(discountStorageKey) !== "true";
  } catch (error) {
    shouldShowDiscount = true;
  }

  if (shouldShowDiscount) {
    window.setTimeout(() => {
      discountModal.hidden = false;
      document.body.classList.add("yuzz-modal-open");
      window.lucide?.createIcons();
    }, 1800);
  }

  discountModal.querySelectorAll("[data-yuzz-discount-close]").forEach((button) => {
    button.addEventListener("click", closeDiscountModal);
  });
}

const revealObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("is-visible");
        revealObserver.unobserve(entry.target);
      }
    });
  },
  { threshold: 0.12 }
);

document.querySelectorAll(".reveal").forEach((element) => revealObserver.observe(element));

document.addEventListener("keydown", (event) => {
  if (event.key === "Escape") {
    closeDiscountModal();
    document.querySelectorAll("[data-yuzz-filter-drawer][open]").forEach((drawer) => {
      drawer.open = false;
    });
    document.body.classList.remove("yuzz-filter-open");
  }
});

if (window.lucide) {
  window.lucide.createIcons();
}
